import { ProcessedUser } from '../../hooks/useProcessedUsers';

export const USER_FILTER_KEYS: (keyof ProcessedUser)[] = ['name', 'email'];

export const USER_TABLE_COLUMNS = [
  { key: 'name', header: 'Name' },
  { key: 'email', header: 'Email' },
  { key: 'role', header: 'Role' },
  { key: 'status', header: 'Status' },
  { key: 'projectCount', header: 'Projects' },
  { key: 'apiKeyCount', header: 'API Keys' },
  { key: 'lastUsed', header: 'Last Used' },
  { key: 'projects', header: 'Project Names' }
];
